import React, { Component } from 'react'
import { getInformationWithData } from '../../../services/CABE';
import "../../../css/inventory-style.css"
import "../../../css/general-style.css"
import '../../../css/table-responsive.css'
import '../../../css/dashboard.css'
import { BsFileArrowUpFill, BsFileArrowDownFill, BsBoxSeam } from "react-icons/bs";
import { AiOutlineReload, AiOutlineSearch } from "react-icons/ai";
import LoadingWindow from '../../../components/LoadingWindow';
import { getIMGByItemCode, ItemDesc, NumberFormat, OrderArray, random_rgba } from '../../../functions/generalFunctions';
import { pricesFormat } from '../../../functions/pricesFormat';
import { DateFormatMAS90, getDateFromReports, OrderArrayByDateGenericLinesDesc } from '../../../functions/dateFormat';
import { ItemPerVendor, ItemsVendor, VendorDetail, Vendors } from './Class';
import { getIndexElement } from '../../../functions/searchInObject';
import ModalOrders from '../../../components/ModalComponent';
import ExcelDocument from '../../../components/ExcelDocument';
import { getValueCookie } from '../../../services/cookieService';
import { getDataSet } from '../../../functions/generateDataSetExcel';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title, PointElement, LineElement, Filler } from 'chart.js';
import { Line } from 'react-chartjs-2';
import { Menu } from "../../../components/Menu/Menu";

export default class VendorReport extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
        ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale,
            LinearScale,
            BarElement,
            Title, CategoryScale,
            LinearScale,
            PointElement,
            LineElement,

            Filler,
        );
    }
    state = {
        BodyFilter: [],
        flag: true,
        ItemVendorList: [],
        VendorItemList: [],
        AllInformation: [],
        mode: 'Item',
        ModalBody: [],
        ModalBodyFilter: [],
        ModalDetailBody: [],
        ModalFilterDetailBody: [],
        showModal1: false,
        order: true,
        currentItem: {
            ItemCode: '',
            ItemCodeDesc: '',
            ProductLine: '',
            itemURL: ''
        },
        optionsLineGraph: {
            responsive: true,
            plugins: {
                legend: {
                    position: 'top',
                },
                title: {
                    display: true,
                    text: 'Costs in different months',
                },
            },
            scales: {
                y: {
                    suggestedMin: 0,
                    suggestedMax: 100
                }
            }
        },
        LineGraphData: {
            labels: [],
            datasets: [
                {
                    fill: true,
                    label: 'Costs in dolars',
                    data: [],
                    borderColor: 'rgb(53, 162, 235)',
                    backgroundColor: 'rgba(53, 162, 235, 0.5)',
                    spanGaps: true
                },
            ],
        }
    }

    async getVendors() {
        this.ModalLoading.current.showState(true);
        const result = await getInformationWithData('/Items/Vendors',{IdCompany:Number(getValueCookie('CompanyId'))})
        result.data=await ItemDesc(result.data,'ItemCodeDesc','ItemCode')
        let ItemVendorList = []
        let VendorItemList = []
        if (result.status.code === 1) {
            for (const item of result.data) {
                const index = getIndexElement(ItemVendorList, 'ItemCode', item.ItemCode)
                const index2 = getIndexElement(VendorItemList, 'VendorNo', item.VendorNo)
                if (index === -1) {
                    let it = new ItemsVendor(item.ItemCode, item.ItemCodeDesc, item.ProductLineDesc)
                    it.addVendor(new Vendors(item.VendorNo, item.VendorName, item.LastReceiptQuantity, item.LastUnitCost, item.LastReceiptDate))
                    ItemVendorList.push(it)
                } else {
                    ItemVendorList[index].addVendor(new Vendors(item.VendorNo, item.VendorName, item.LastReceiptQuantity, item.LastUnitCost, item.LastReceiptDate))
                    ItemVendorList[index].VendorList = OrderArrayByDateGenericLinesDesc(ItemVendorList[index].VendorList, 'LastReceiptDate')
                }

                if (index2 === -1) {
                    let vend = new Vendors(item.VendorNo, item.VendorName, null, null, null)
                    vend.addItem(new ItemPerVendor(item.LastReceiptQuantity, item.LastUnitCost, item.LastReceiptDate, item.ItemCode, item.ItemCodeDesc, item.ProductLineDesc))
                    VendorItemList.push(vend)
                } else {
                    VendorItemList[index2].addItem(new ItemPerVendor(item.LastReceiptQuantity, item.LastUnitCost, item.LastReceiptDate, item.ItemCode, item.ItemCodeDesc, item.ProductLineDesc))
                    VendorItemList[index2].ItemList = OrderArrayByDateGenericLinesDesc(VendorItemList[index2].ItemList, 'LastReceiptDate')
                }
            }
        }
        
        this.setState({ ItemVendorList: ItemVendorList, VendorItemList: VendorItemList, BodyFilter: ItemVendorList, mode: 'Item', AllInformation: result.data })
        this.ModalLoading.current.showState(false);
        
        document.getElementById("excelContainerVendors").classList.remove("d-none");
        document.getElementById("loadDataContainerVendors").classList.replace("col-12", "col-6");
    }

    valueRadioButton = async e => {
        let stat = e.target.value
        if (stat === 'Item') {
            this.setState({ BodyFilter: this.state.ItemVendorList, mode: stat })

        } else {
            this.setState({ BodyFilter: this.state.VendorItemList, mode: stat })
        }
    }

    async getVendorsList(index, it) {
        this.clearModal()
        await this.handleModalOpen("showModal1")
        this.ModalLoading.current.showState(true);
        const data = {
            ItemCode: it.ItemCode,
            idCompany: Number(getValueCookie('CompanyId'))
        }

        const result = await getInformationWithData('/purchase/History/getDetialByItem', data)

        if (result.status.code === 1) {
            let allData = []
            let dates = []
            let date2 = []
            for (const row of result.data) {

                const index = getIndexElement(allData, 'VendorNo', row.VendorNo)
                const index2 = getIndexElement(dates, 'OrderDate', DateFormatMAS90(row.PurchaseOrderDate))

                if (index === -1) {
                    let newVendorDetail = new VendorDetail(row.VendorNo, row.PurchaseName)
                    newVendorDetail.addDetailVendor(row.PurchaseOrderNo, DateFormatMAS90(row.PurchaseOrderDate), row.QuantityInvoiced, row.UnitCost)
                    allData.push(newVendorDetail)
                } else {
                    allData[index].addDetailVendor(row.PurchaseOrderNo, DateFormatMAS90(row.PurchaseOrderDate), row.QuantityInvoiced, row.UnitCost)
                    allData[index].VendorName = row.PurchaseName
                }

                if (index2 === -1) {
                    dates.push({ OrderDate: DateFormatMAS90(row.PurchaseOrderDate) })
                    date2.push(DateFormatMAS90(row.PurchaseOrderDate))
                }
            }

            let dataSet = []

            for (const Vendor of allData) {
                let color = random_rgba()
                const vendordata = {

                    label: Vendor.VendorName,
                    data: [],
                    borderColor: color,
                    backgroundColor: color,
                    spanGaps: true
                }
                for (const date of dates) {

                    const index = getIndexElement(Vendor.Detail, 'OrderDate', date.OrderDate)
                    if (index !== -1) {
                        vendordata.data.push(Vendor.Detail[index].UnitCost)
                    } else {
                        vendordata.data.push(null)
                    }
                }
                dataSet.push(vendordata)
            }

            const graphData = {
                labels: date2,
                datasets: dataSet
            }
            this.setState({ LineGraphData: graphData })
        }


        const temporal = this.state.currentItem
        temporal.ItemCode = it.ItemCode
        temporal.ItemCodeDesc = it.ItemCodeDesc
        temporal.ProductLine = it.ProductLineDesc
        temporal.itemURL = await getIMGByItemCode(it.ItemCode)
        const index2 = getIndexElement(this.state.ItemVendorList, 'ItemCode', it.ItemCode)
        const item = this.state.ItemVendorList[index2]
        
        await this.setState({
            ModalBody: item.VendorList,
            ModalBodyFilter: item.VendorList,
            currentItem: temporal,
            ModalDetailBody: result.data,
            ModalFilterDetailBody: result.data
        })
        this.ModalLoading.current.showState(false);

    }

    clearModal() {
        const temporal = {
            ItemCode: '',
            ItemCodeDesc: '',
            ProductLine: '',
            itemURL: ''
        }


        this.setState({
            ModalBody: [],
            ModalBodyFilter: [],
            currentItem: temporal,
            ModalDetailBody: [],
            ModalFilterDetailBody: []
        })
    }


    async getItemList(index, vend) {
        const index2 = getIndexElement(this.state.VendorItemList, 'VendorNo', vend.VendorNo)
        const vendor = this.state.VendorItemList[index2]
        const temporal = this.state.currentItem
        temporal.ItemCode = vend.VendorNo
        temporal.ItemCodeDesc = vend.VendorName

        await this.setState({ ModalBody: vendor.ItemList, ModalBodyFilter: vendor.ItemList, currentItem: temporal })
        this.handleModalOpen("showModal1")


    }

    handleModalClose = (modal) => {
        this.setState({ [modal]: false })
    }

    handleModalOpen = (modal) => {
        this.setState({ [modal]: true })
    }

    OrderInformation(array, key, state) {
        const order = OrderArray(array, key, this.state.order)
        this.setState({ [state]: order, order: !this.state.order })
    }
    contains(parametro, busqueda) {
        return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
    }


    searchVendor = e => {

        let search = e.target.value;

        let Vendor
        if (this.state.mode === 'Item') {
            Vendor = this.state.ItemVendorList.filter((item) => {
                if (((
                    this.contains(item.ItemCode, search) ||
                    this.contains(item.ProductLineDesc, search) ||
                    this.contains(item.ItemCodeDesc, search)
                ))
                ) {
                    return item
                } else {
                    return null
                }
            });

        } else {
            Vendor = this.state.VendorItemList.filter((vendor) => {
                if (((
                    this.contains(vendor.VendorNo, search) ||
                    this.contains(vendor.VendorName, search)
                ))
                ) {
                    return vendor
                } else {
                    return null
                }
            });

        }

        this.setState({ BodyFilter: Vendor });
    }
    searchVendorHistory = e => {
        let search = e.target.value;
        
        let Vendor=this.state.ModalDetailBody.filter((vendor)=>{
            if ((this.contains(vendor.VendorNo, search))
            ||this.contains(vendor.PurchaseName,search)
            ||this.contains(vendor.PurchaseOrderNo,search)){
                return vendor
            } else {
                return null
            }
        })
        this.setState({ModalFilterDetailBody:Vendor})
    }



    searchVendorModal = e => {

        let search = e.target.value;

        let Vendor = []
        if (this.state.mode === 'Item') {
            Vendor = this.state.ModalBody.filter((vendor) => {
                if (((
                    this.contains(vendor.VendorNo, search) ||
                    this.contains(vendor.VendorName, search)
                ))
                ) {
                    return vendor
                } else {
                    return null
                }
            });

        } else {
            Vendor = this.state.ModalBody.filter((item) => {
                if (((
                    this.contains(item.ItemCode, search) ||
                    this.contains(item.ProductLineDesc, search) ||
                    this.contains(item.ItemCodeDesc, search)
                ))
                ) {
                    return item
                } else {
                    return null
                }
            });
        }

        this.setState({ ModalBodyFilter: Vendor });
    }


    render() {
        const hasData = this.state.AllInformation.length !== 0
        const isItemMode = this.state.mode === 'Item'
        const pillLabelStyle = (active) => ({
            display: 'inline-flex', alignItems: 'center', gap: '0.35rem', padding: '0.35rem 0.9rem',
            borderRadius: '999px', fontSize: '0.8125rem', fontWeight: 700, cursor: 'pointer', userSelect: 'none',
            background: active ? 'rgba(255,255,255,0.25)' : 'transparent',
            color: active ? 'white' : 'rgba(255,255,255,0.55)'
        })

        return (
            // Old-shell page (App.js) — same fix as PurchaseProcess.js / HistoryPurchaseOrderView.js:
            // cancel .container-fluid.generalContainer's 12px side gutters + 40px top padding so the
            // hero can bleed edge-to-edge and sit flush with the topbar.
            <div className='dash-page' style={{ marginLeft: '-0.75rem', marginRight: '-0.75rem', position: 'relative', top: '-40px', paddingTop: '30px' }}>
                {this.props.showMenu && <Menu />}
                <LoadingWindow ref={this.ModalLoading} />

                {/* Hero */}
                <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '3rem 2rem', display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                    <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                        <BsBoxSeam style={{ color: 'white', fontSize: '1.75rem' }} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Vendor Report</h1>
                        <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>
                            {hasData ? `${this.state.BodyFilter.length.toLocaleString('en-US')} ${isItemMode ? 'items' : 'vendors'} loaded` : 'Load data to view items and their vendors'}
                        </p>
                    </div>
                    <button id="loadDataContainerVendors" onClick={() => this.getVendors()}
                        style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '8px', color: 'white', fontWeight: 700, padding: '0.45rem 1rem', fontSize: '0.875rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
                        <AiOutlineReload /> Load Data
                    </button>
                </div>

                <div style={{ padding: '1.5rem 2rem' }}>
                {!hasData ? (
                    <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                        <BsBoxSeam style={{ fontSize: '3rem', opacity: 0.2, marginBottom: '1rem' }} />
                        <p style={{ fontSize: '0.9rem', fontWeight: 500 }}>Click <strong>Load Data</strong> to fetch the latest vendor data.</p>
                    </div>
                ) : (
                /* Mode toggle + Excel + search + table */
                <div className='card' style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                    <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.75rem' }}>
                        <div style={{ display: 'inline-flex', background: 'rgba(255,255,255,0.08)', borderRadius: '999px', padding: '3px', gap: '2px' }}>
                            <label style={pillLabelStyle(isItemMode)}>
                                <input className="d-none" value={'Item'} onChange={this.valueRadioButton} checked={isItemMode} type="radio" id='typeItemVendorReport' name="typeVendorReport" />
                                Item List
                            </label>
                            <label style={pillLabelStyle(!isItemMode)}>
                                <input className="d-none" value={'Vendor'} onChange={this.valueRadioButton} checked={!isItemMode} type="radio" id='typeVendorVendorReport' name="typeVendorReport" />
                                Vendor List
                            </label>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', flexWrap: 'wrap' }}>
                            <div id="excelContainerVendors" className="d-none">
                                <ExcelDocument
                                    hidden={this.state.AllInformation.length === 0}
                                    archname={'Vendors ' + getValueCookie('Company') + ' ' + getDateFromReports()}
                                    sheetname={'Items Vendor Report ' + getValueCookie('Company')}
                                    data={getDataSet(this.state.ItemVendorList, ['Item Code', 'Product Line', 'Description'], ['ItemCode', 'ProductLineDesc', 'ItemCodeDesc'])}
                                    sheetname2={['Vendors List ' + getValueCookie('Company'), 'All Information Vendors Report ' + getValueCookie('Company')]}
                                    data2={[
                                        getDataSet(this.state.VendorItemList, ['Vendor No', 'Vendor Name'], ['VendorNo', 'VendorName']),
                                        getDataSet(this.state.AllInformation, ['Vendor No', 'Vendor Name', 'Item Code', 'Product Line', 'Description', 'Last Receipt Date', 'Last Unit Cost ($)', 'Last Receipt Quantity'], ['VendorNo', 'VendorName', 'ItemCode', 'ProductLineDesc', 'ItemCodeDesc', 'LastReceiptDate', 'LastUnitCost', 'LastReceiptQuantity'])
                                    ]}
                                />
                            </div>
                            <div style={{ position: 'relative', minWidth: '220px', flex: '1 1 220px', maxWidth: '380px' }}>
                                <AiOutlineSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.5)', fontSize: '1rem' }} />
                                <input type="text" autoComplete='off' id='searchPrincipalVendor2'
                                    placeholder={isItemMode ? 'Search Item by ItemCode, Line Product, Description...' : 'Search Vendor by VendorNo, Vendor Name...'}
                                    onChange={this.searchVendor}
                                    style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', color: 'white', fontSize: '0.8125rem', padding: '0.4rem 0.75rem 0.4rem 2rem', width: '100%', outline: 'none' }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='card-body p-0'>
                        {
                            this.state.mode === 'Item' ?

                                <div className='tableFixHead'>
                                    <table className='table align-middle table-hover mb-0'>
                                        <thead className='table-dark'>
                                            <tr className='text-center'>
                                                <th onClick={() => this.OrderInformation(this.state.BodyFilter, 'ItemCode', 'BodyFilter')} style={{ cursor: 'pointer' }}>Item Code <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                <th onClick={() => this.OrderInformation(this.state.BodyFilter, 'ProductLineDesc', 'BodyFilter')} style={{ cursor: 'pointer' }}>Product Line <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                <th onClick={() => this.OrderInformation(this.state.BodyFilter, 'ItemCodeDesc', 'BodyFilter')} style={{ cursor: 'pointer' }}>Description <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.BodyFilter.map((item, i) => (
                                                    <tr onClick={() => this.getVendorsList(i, item)} key={i} style={{ cursor: 'pointer' }}>
                                                        <td className='text-center'>{item.ItemCode}</td>
                                                        <td className='text-center'>{item.ProductLineDesc}</td>
                                                        <td className='text-center'>{item.ItemCodeDesc}</td>
                                                    </tr>
                                                ))

                                            }
                                        </tbody>

                                    </table>
                                </div>
                                :
                                <div className='tableFixHead'>
                                    <table className='table align-middle table-hover mb-0'>
                                        <thead className='table-dark'>
                                            <tr className='text-center'>
                                                <th onClick={() => this.OrderInformation(this.state.BodyFilter, 'VendorNo', 'BodyFilter')} style={{ cursor: 'pointer' }}>Vendor No <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                <th onClick={() => this.OrderInformation(this.state.BodyFilter, 'VendorName', 'BodyFilter')} style={{ cursor: 'pointer' }}>Vendor Name <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.BodyFilter.map((vendor, v) => (
                                                    <tr onClick={() => this.getItemList(v, vendor)} key={v} style={{ cursor: 'pointer' }}>
                                                        <td className='text-center'>{vendor.VendorNo}</td>
                                                        <td className='text-center'>{vendor.VendorName}</td>
                                                    </tr>
                                                ))

                                            }
                                        </tbody>

                                    </table>
                                </div>
                        }
                    </div>
                </div>
                )}
                </div>

                <ModalOrders title={this.state.mode === 'Item' ? 'Vendors Detail' : 'Items Detail'} show={this.state.showModal1} close={(modal = "showModal1") => this.handleModalClose(modal)}>
                    <div className='row'>
                        <div className='col-1 d-none d-md-block'></div>
                        {
                            this.state.mode === 'Item' ?
                                <div className='col-12 col-md-10'>
                                    <div className='row g-3 align-items-center'>
                                        <div className='col-12 col-md-4 text-center'>
                                            <div className='ItemImg' style={{ margin: '0 auto' }}>
                                                <img key={this.state.currentItem.itemURL} className='pb-5 pt-5' id='ShortsProductImg' src={this.state.currentItem.itemURL !== '' ? this.state.currentItem.itemURL : '/assets/notavailable.png'} alt='ProductImg' />
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-8'>
                                            <span className='badge rounded-pill text-bg-primary me-2' style={{ fontSize: '0.8rem' }}>{this.state.currentItem.ItemCode}</span>
                                            <span className='badge rounded-pill text-bg-secondary' style={{ fontSize: '0.8rem' }}>{this.state.currentItem.ProductLine}</span>
                                            <div style={{ fontSize: '1rem', fontWeight: 700, color: '#0F172A', marginTop: '10px' }}>{this.state.currentItem.ItemCodeDesc}</div>
                                        </div>

                                        <div className='col-12 col-md-8'>
                                            <div style={{ position: 'relative' }}>
                                                <AiOutlineSearch style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94A3B8' }} />
                                                <input type="text" autoComplete='off' className="form-control" style={{ paddingLeft: '2.25rem', borderRadius: '8px' }} id='searchVendorVendorModal' placeholder={'Search Vendor by VendorNo, Vendor Name...'} onChange={this.searchVendorModal} />
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-4 text-md-end">
                                            <ExcelDocument
                                                hidden={this.state.ModalBody.length === 0}
                                                archname={'Vendor List per Item ' + this.state.currentItem.ItemCode + " " + getValueCookie('Company') + ' ' + getDateFromReports()}
                                                sheetname={'Vendor List ' + getValueCookie('Company')}
                                                data={getDataSet(this.state.ModalBody, ['Vendor No', 'Vendor Name', 'Last Receipt Date', 'Last Receipt Quantity', 'Last Unit Cost($)'], ['VendorNo', 'VendorName', 'LastReceiptDate', 'LastReceiptQuantity', 'LastUnitCost'])}
                                                buttonTitle="Download Vendor List "

                                            />
                                        </div>
                                        <div className='col-12 tableFixHead mt-2'>
                                            <table className='table align-middle table-hover mb-0'>
                                                <thead className='table-dark'>
                                                    <tr className='text-center'>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'VendorNo', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Vendor No <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'VendorName', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Vendor Name <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'LastReceiptDate', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Last Receipt Date <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'LastReceiptQuantity', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Last Receipt Quantity <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'LastUnitCost', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Last Unit Cost <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.ModalBodyFilter.map((item, i) => (
                                                            <tr key={i}>
                                                                <td className='text-center'>{item.VendorNo}</td>
                                                                <td className='text-center'>{item.VendorName}</td>
                                                                <td className='text-center'>{item.LastReceiptDate ? DateFormatMAS90(item.LastReceiptDate) : 'Not available'}</td>
                                                                <td className='text-center'>{item.LastReceiptQuantity ? NumberFormat(pricesFormat(item.LastReceiptQuantity)) : 0}</td>
                                                                <td className='text-end'>$</td>
                                                                <td className='text-end'>{item.LastUnitCost ? NumberFormat(pricesFormat(item.LastUnitCost)) : '0.00'}</td>
                                                            </tr>
                                                        ))

                                                    }
                                                </tbody>

                                            </table>
                                        </div>
                                        <div className='col-12 card mt-3' style={{ borderRadius: '12px', border: '1px solid #E2E8F0', padding: '1rem' }}>
                                            <Line options={this.state.optionsLineGraph} data={this.state.LineGraphData} />
                                        </div>
                                        <div className='col-12 col-md-8 mt-3'>
                                            <div style={{ position: 'relative' }}>
                                                <AiOutlineSearch style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94A3B8' }} />
                                                <input type="text" autoComplete='off' className="form-control" style={{ paddingLeft: '2.25rem', borderRadius: '8px' }} id='searchVendorModalHistory' placeholder={'Search Vendor by VendorNo, Vendor Name, Purchase Order No...'} onChange={this.searchVendorHistory} />
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-4 mt-3 text-md-end">
                                            <ExcelDocument
                                                hidden={this.state.ModalFilterDetailBody.length === 0}
                                                archname={'PO History Item ' + this.state.currentItem.ItemCode + " " + getValueCookie('Company') + ' ' + getDateFromReports()}
                                                sheetname={'Vendor List ' + getValueCookie('Company')}
                                                data={getDataSet(this.state.ModalFilterDetailBody, ['Vendor No', 'Vendor Name', 'Purchase Order No', 'Purchase Order Date', 'Quantity Invoiced','Unit Cost'], ['VendorNo', 'PurchaseName', 'PurchaseOrderNo', 'PurchaseOrderDate', 'QuantityInvoiced','UnitCost'])}
                                                buttonTitle="Download PO History Item"
                                            />
                                        </div>
                                        <div className='col-12 tableFixHead mt-2'>
                                            <table className='table align-middle table-hover mb-0'>
                                                <thead className='table-dark'>
                                                    <tr className='text-center'>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalFilterDetailBody, 'VendorNo', 'ModalFilterDetailBody')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Vendor No <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalFilterDetailBody, 'VendorName', 'ModalFilterDetailBody')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Vendor Name <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalFilterDetailBody, 'PurchaseOrderNo', 'ModalFilterDetailBody')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Purchase Order No<BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalFilterDetailBody, 'PurchaseOrderDate', 'ModalFilterDetailBody')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Receipt Date <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalFilterDetailBody, 'QuantityInvoiced', 'ModalFilterDetailBody')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Quantity Receipt<BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalFilterDetailBody, 'UnitCost', 'ModalFilterDetailBody')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Last Unit Cost <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.ModalFilterDetailBody.map((item, i) => (
                                                            <tr key={i}>
                                                                <td className='text-center'>{item.VendorNo}</td>
                                                                <td className='text-center'>{item.PurchaseName}</td>
                                                                <td className='text-center'>{item.PurchaseOrderNo}</td>
                                                                <td className='text-center'>{item.PurchaseOrderDate ? DateFormatMAS90(item.PurchaseOrderDate) : 'Not available'}</td>
                                                                <td className='text-center'>{item.QuantityInvoiced ? NumberFormat(pricesFormat(item.QuantityInvoiced)) : 0}</td>
                                                                <td className='text-end'>$</td>
                                                                <td className='text-end'>{item.UnitCost ? NumberFormat(pricesFormat(item.UnitCost)) : '0.00'}</td>
                                                            </tr>
                                                        ))

                                                    }
                                                </tbody>

                                            </table>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className='col-12 col-md-10'>
                                    <div className='row g-3'>
                                        <div className='col-12'>
                                            <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Vendor No</div>
                                            <div style={{ fontSize: '1rem', fontWeight: 700, color: '#0F172A', marginBottom: '12px', wordBreak: 'break-word' }}>{this.state.currentItem.ItemCode}</div>
                                            <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Vendor Name</div>
                                            <div style={{ fontSize: '1rem', fontWeight: 700, color: '#0F172A', wordBreak: 'break-word' }}>{this.state.currentItem.ItemCodeDesc}</div>
                                        </div>
                                        <div className='col-12 col-md-8'>
                                            <div style={{ position: 'relative' }}>
                                                <AiOutlineSearch style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94A3B8' }} />
                                                <input type="text" autoComplete='off' className="form-control" style={{ paddingLeft: '2.25rem', borderRadius: '8px' }} id='searchItemVendorModal' placeholder={'Search Item by ItemCode, Product Line, Description...'} onChange={this.searchVendorModal} />
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-4 text-md-end">
                                            <ExcelDocument
                                                hidden={this.state.ModalBody.length === 0}
                                                archname={'Item List per Vendor ' + this.state.currentItem + " " + getValueCookie('Company') + ' ' + getDateFromReports()}
                                                sheetname={'Item List ' + getValueCookie('Company')}
                                                data={getDataSet(this.state.ModalBody, ['Item Code', 'Product Line', 'Description', 'Last Receipt Date', 'Last Receipt Quantity', 'Last Unit Cost($)'], ['ItemCode', 'ProductLineDesc', 'ItemCodeDesc', 'LastReceiptDate', 'LastReceiptQuantity', 'LastUnitCost'])}
                                            />
                                        </div>
                                        <div className='col-12 tableFixHead'>
                                            <table className='table align-middle table-hover mb-0'>
                                                <thead className='table-dark'>
                                                    <tr className='text-center'>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'ItemCode', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Item Code <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'ProductLineDesc', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Product Line<BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'ItemCodeDesc', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Description <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'LastReceiptDate', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Last Receipt Date <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'LastReceiptQuantity', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Last Receipt Quantity <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'LastUnitCost', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Last Unit Cost <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {

                                                        this.state.ModalBodyFilter.map((item, i) => (
                                                            <tr key={i}>
                                                                <td className='text-center'>{item.ItemCode}</td>
                                                                <td className='text-center'>{item.ProductLineDesc}</td>
                                                                <td className='text-start'>{item.ItemCodeDesc}</td>
                                                                <td className='text-center'>{item.LastReceiptDate ? DateFormatMAS90(item.LastReceiptDate) : 'Not available'}</td>
                                                                <td className='text-center'>{item.LastReceiptQuantity ? NumberFormat(pricesFormat(item.LastReceiptQuantity)) : 0}</td>
                                                                <td className='text-end'>$</td>
                                                                <td className='text-end'>{item.LastUnitCost ? NumberFormat(pricesFormat(item.LastUnitCost)) : '0.00'}</td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>

                                            </table>
                                        </div>
                                    </div></div>
                        }
                        <div className='col-1 d-none d-md-block'></div>
                    </div>
                </ModalOrders>

            </div>
        )
    }
}
